<template>
	<div>
		<tabs v-if="tabs && tabs.length > 0">
			<tabs-item
				v-for="(tab, key) in tabs"
				:key="key"
				:active="activeTab.id === tab.id"
				@click="setActiveTab(tab)"
				>{{ tab.label }}</tabs-item
			>
		</tabs>

		<section
			role="feed"
			class="scroll"
			:class="{
				'negative-bottom': noBottom,
				inner: inner,
				'align-center': headerCentral
			}"
			tabindex="0"
		>
			<slot></slot>
		</section>
	</div>
</template>

<script>
export default {
	props: {
		tabs: {
			type: Array,
			default: () => []
		},
		noBottom: {
			type: Boolean,
			default: false
		},
		inner: {
			type: Boolean,
			default: false
		},
		headerCentral: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			activeTab: null
		};
	},
	methods: {
		setActiveTab(tab) {
			// set the state to active
			this.activeTab = tab;

			// and also perform the necessary store method
			if (tab.dispatchAction) {
				this.$store.dispatch(tab.dispatchAction);
			}

			// then tell the parent what we have done
			this.$emit("tabClick", this.activeTab);
		}
	},
	watch: {
		tabs: {
			immediate: true,
			deep: true,
			handler(newValue, oldValue) {
				const activeTab = newValue.filter(tab => tab.active);
				this.activeTab = activeTab[0];
			}
		}
	}
};
</script>

<style scoped lang="scss">
ol {
	list-style-type: none;
	margin: 0;
	padding: 0;

	@media screen and (max-width: 1023px) {
		li:first-of-type {
			padding-top: 20px;
		}
	}
}

.scroll {
	max-height: 300px;
	overflow-y: auto;
	padding: 0 10px;

	&.inner {
		padding: 0;
	}

	&.negative-bottom {
		@media (min-width: 640px) {
			margin-bottom: -1em; //For questions, obvz
		}
	}
}
</style>
